// extracted by mini-css-extract-plugin
export var infoRow = "_qx-2";
export var labelContainer = "_qx-0";
export var rightInfo = "_qx-1";